import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';
import Paper from '@zenbusiness/zui/Paper';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

export function NoSubscriptionsLanding({ businessEntity }) {
  const navigate = useNavigate();
  const { uuid, name, domesticJurisdiction } = businessEntity;
  const isFreeDash = domesticJurisdiction === 'XX';

  return (
    <Paper sx={{ pt: 2, pb: 4, mt: 3 }}>
      <Stack alignItems="center" gap={3}>
        <Text size="2xl" weight="bold" family="secondary" align="center" sx={{ maxWidth: 700, pt: 4 }}>
          {isFreeDash ? (
            <FormattedMessage id="dashboard.subscriptions.noSubscriptions.heading" />
          ) : (
            <FormattedMessage
              id="dashboard.subscriptions.noSubscriptions.headingForEntity"
              values={{ entityName: name }}
            />
          )}
        </Text>
        <Text size="md" color="secondary" align="center">
          <FormattedMessage id="dashboard.subscriptions.noSubscriptions.body" />
        </Text>
        <Button
          variant="contained"
          onClick={() => navigate(`/dashboard/${uuid}`)}
          clickstreamProps={{ elementName: 'no_subscriptions_back_to_home_button' }}
        >
          <FormattedMessage id="dashboard.subscriptions.noSubscriptions.backToHome" />
        </Button>
      </Stack>
    </Paper>
  );
}

NoSubscriptionsLanding.propTypes = {
  businessEntity: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    domesticJurisdiction: PropTypes.string.isRequired,
  }).isRequired,
};
